const CaseRecommendationPaidIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="34" viewBox="0 0 38 34" fill="none">
      <ellipse opacity="0.4" cx="21.5334" cy="32.3664" rx="14.7775" ry="1.40738" fill="#A2BADC" />
      <path
        d="M12.0138 8.99579L9.20559 8.54823C8.95295 8.50801 8.77378 8.27971 8.79693 8.02526C8.85733 7.35343 8.94288 6.64137 9.06266 5.89411C9.18143 5.15087 9.32134 4.45089 9.47232 3.79615C9.5297 3.54774 9.77127 3.38582 10.0239 3.42605C10.96 3.57489 11.8961 3.72475 12.8322 3.8736L12.0148 8.99478L12.0138 8.99579Z"
        fill="#3879D5"
      />
      <path
        d="M31.0566 8.99579L33.8649 8.54823C34.1175 8.50801 34.2967 8.27971 34.2735 8.02526C34.2131 7.35343 34.1276 6.64137 34.0078 5.89411C33.889 5.15087 33.7491 4.45089 33.5981 3.79615C33.5407 3.54774 33.2992 3.38582 33.0465 3.42605C32.1104 3.57489 31.1744 3.72475 30.2383 3.8736L31.0556 8.99478L31.0566 8.99579Z"
        fill="#3879D5"
      />
      <path
        d="M12.4186 26.3408C12.4186 26.3408 12.2475 29.7694 12.6984 32.0172C12.7809 32.4265 13.1433 32.7192 13.561 32.7192H15.7955C16.2052 32.7192 16.5595 32.4386 16.6531 32.0403C16.9349 30.8345 17.5248 28.3533 17.8277 27.3627L12.4186 26.3398V26.3408Z"
        fill="#3879D5"
      />
      <path
        d="M30.6494 26.3408C30.6494 26.3408 30.8205 29.7694 30.3696 32.0172C30.287 32.4265 29.9247 32.7192 29.507 32.7192H27.2724C26.8628 32.7192 26.5085 32.4386 26.4149 32.0403C26.133 30.8345 25.5432 28.3533 25.2402 27.3627L30.6494 26.3398V26.3408Z"
        fill="#3879D5"
      />
      <path
        d="M33.141 19.452C33.141 19.452 34.823 20.7685 35.0937 21.8095C35.1149 21.8899 35.1098 21.9744 35.0826 22.0518C35.0152 22.2419 34.9015 22.6844 35.0434 23.2135C35.2014 23.8028 35.7892 24.2353 36.2573 24.187C37.1491 24.0935 38.3318 22.4541 37.913 20.0012C37.4943 17.5482 35.597 14.0895 33.0293 12.082L33.141 19.452Z"
        fill="#3879D5"
      />
      <path
        d="M28.725 27.7162C23.9319 28.4785 19.1387 28.4785 14.3456 27.7162C11.2746 27.1067 9.70845 24.6216 9.52325 22.0519C9.16492 16.1261 9.68832 10.0787 10.873 3.92663C11.184 2.38585 12.3718 0.909432 14.1332 0.605702C19.0683 -0.201901 24.0023 -0.201901 28.9374 0.605702C30.717 0.881272 31.8876 2.38585 32.1976 3.92663C33.3823 10.0787 33.9057 16.1251 33.5474 22.0519C33.3622 24.6216 31.7155 27.1912 28.725 27.7162Z"
        fill="#71AFFF"
      />
      <path
        d="M23.1009 12.9961L21.7199 14.2673L23.1713 20.529C23.1985 20.6467 23.1663 20.7694 23.0838 20.8579L21.8024 22.2478C21.6585 22.4047 21.4109 22.4047 21.2659 22.2478L19.9836 20.8579C19.9021 20.7694 19.8689 20.6457 19.896 20.529L21.3475 14.2673L19.9665 12.9961L21.5337 11.8848L23.0999 12.9961H23.1009Z"
        fill="white"
      />
      <path
        d="M29.4237 11.5612C26.1364 12.5931 22.9084 13.0708 21.8757 13.2066C21.6492 13.2367 21.4207 13.2367 21.1942 13.2066C20.1615 13.0708 16.9335 12.5941 13.6452 11.5612C12.6819 11.2585 12.077 10.306 12.2018 9.30533C12.3639 8.01095 12.5913 6.2831 12.7705 5.2653C13.008 3.97897 13.8404 2.77813 15.4217 2.48647C19.4942 1.80659 23.5737 1.80659 27.6452 2.48647C29.2224 2.75902 30.0589 3.97998 30.2964 5.2653C30.4746 6.2821 30.703 8.01095 30.8651 9.30533C30.9899 10.306 30.385 11.2585 29.4217 11.5612H29.4237Z"
        fill="#3879D5"
      />
      <path
        d="M18.1744 8.02347C17.5353 8.11197 16.8971 8.11197 16.258 8.02347C15.954 7.9772 15.644 7.66744 15.5977 7.36371C15.5091 6.72507 15.5091 6.08743 15.5977 5.44879C15.644 5.14506 15.954 4.8353 16.258 4.78903C16.8971 4.70053 17.5353 4.70053 18.1744 4.78903C18.4784 4.8353 18.7884 5.14506 18.8347 5.44879C18.9233 6.08743 18.9233 6.72507 18.8347 7.36371C18.7884 7.66744 18.4784 7.9772 18.1744 8.02347Z"
        fill="#71AFFF"
      />
      <path
        d="M18.0836 7.56797C17.5058 7.66653 16.9281 7.66653 16.3513 7.56797C16.2164 7.54383 16.0806 7.40806 16.0564 7.27329C15.9578 6.696 15.9578 6.11871 16.0564 5.54243C16.0806 5.40766 16.2164 5.27189 16.3513 5.24775C16.9291 5.14919 17.5068 5.14919 18.0836 5.24775C18.2185 5.27189 18.3543 5.40766 18.3785 5.54243C18.4771 6.11972 18.4771 6.69701 18.3785 7.27329C18.3543 7.40806 18.2185 7.54383 18.0836 7.56797Z"
        fill="white"
      />
      <path
        d="M26.8092 8.02347C26.17 8.11197 25.5319 8.11197 24.8927 8.02347C24.5888 7.9772 24.2787 7.66744 24.2324 7.36371C24.1439 6.72507 24.1439 6.08743 24.2324 5.44879C24.2787 5.14506 24.5888 4.8353 24.8927 4.78903C25.5319 4.70053 26.17 4.70053 26.8092 4.78903C27.1132 4.8353 27.4232 5.14506 27.4695 5.44879C27.5581 6.08743 27.5581 6.72507 27.4695 7.36371C27.4232 7.66744 27.1132 7.9772 26.8092 8.02347Z"
        fill="#71AFFF"
      />
      <path
        d="M26.7183 7.56797C26.1406 7.66653 25.5628 7.66653 24.9861 7.56797C24.8512 7.54383 24.7153 7.40806 24.6912 7.27329C24.5925 6.696 24.5925 6.11871 24.6912 5.54243C24.7153 5.40766 24.8512 5.27189 24.9861 5.24775C25.5638 5.14919 26.1416 5.14919 26.7183 5.24775C26.8532 5.27189 26.9891 5.40766 27.0133 5.54243C27.1119 6.11972 27.1119 6.69701 27.0133 7.27329C26.9891 7.40806 26.8532 7.54383 26.7183 7.56797Z"
        fill="white"
      />
      <path
        d="M23.2462 8.77344C23.3499 8.77344 23.4334 8.86295 23.4203 8.96553C23.3147 9.81739 22.5104 10.4802 21.5341 10.4802C20.5577 10.4802 19.7545 9.81739 19.6478 8.96553C19.6347 8.86295 19.7193 8.77344 19.822 8.77344H23.2452H23.2462Z"
        fill="white"
      />
      <path
        d="M7.52309 9.52869L0.719399 12.6875C0.322086 12.8719 0.150191 13.3422 0.335461 13.7377L6.71 27.3484C6.89527 27.744 7.36754 27.9152 7.76486 27.7307L14.5685 24.5719C14.9659 24.3874 15.1378 23.9172 14.9525 23.5216L8.57795 9.91096C8.39268 9.51538 7.92041 9.34423 7.52309 9.52869Z"
        fill="#A2BADC"
      />
      <path
        d="M7.53078 10.4013L1.38458 13.2548C1.13011 13.373 1.02002 13.6741 1.13868 13.9275L7.08189 26.6172C7.20055 26.8706 7.50303 26.9802 7.75749 26.862L13.9037 24.0085C14.1582 23.8904 14.2683 23.5892 14.1496 23.3359L8.20638 10.6461C8.08772 10.3928 7.78525 10.2832 7.53078 10.4013Z"
        fill="white"
      />
      <path
        d="M5.7716 11.7435L3.56409 12.7683C3.5004 12.7979 3.42439 12.7867 3.372 12.7386L3.05664 12.4512L4.24206 11.3477L5.85275 11.1523L5.87124 11.5778C5.87432 11.6484 5.83426 11.7138 5.77057 11.7435H5.7716Z"
        fill="#A2BADC"
      />
      <path
        d="M8.69762 20.884C10.1301 20.219 10.7496 18.5239 10.0817 17.0986C9.41384 15.6734 7.71134 15.0556 6.27982 15.7206C4.84739 16.3856 4.22789 18.0806 4.89575 19.5059C5.56361 20.9312 7.2661 21.5489 8.69762 20.884Z"
        fill="#22D081"
      />
      <path
        d="M8.45833 20.3624C9.60428 19.8301 10.0997 18.4748 9.56505 17.3338C9.03039 16.1929 7.66913 15.6996 6.52318 16.2319C5.37723 16.7643 4.88181 18.1196 5.41646 19.2605C5.95112 20.4015 7.31239 20.8948 8.45833 20.3624Z"
        fill="#41E596"
      />
      <path
        d="M6.4375 18.7485L7.48217 19.1282L8.20934 17.1406"
        stroke="white"
        strokeWidth="0.562953"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.28982 20.0547C3.28982 20.0547 3.66298 20.349 4.23869 20.4871C4.88192 20.6406 5.5808 20.9758 6.1337 22.0586C6.56343 22.9007 6.45486 24.4323 4.8509 24.1843C2.56721 23.8318 2.17489 20.4798 3.28982 20.0556V20.0547Z"
        fill="#3879D5"
      />
      <path
        d="M13.0218 16.8872C12.6952 16.5711 12.3181 16.1836 11.9663 15.8316C11.7011 15.5662 11.3536 15.1107 10.8637 15.3905C10.2071 15.8317 10.5589 16.5354 12.2204 17.6797L12.9512 19.2403C12.9512 19.2403 14.2262 18.0509 13.0218 16.8872Z"
        fill="#3879D5"
      />
    </svg>
  );
};

export default CaseRecommendationPaidIcon;
